<template>
<div class="register-form-holder">
  <form
    role="form"
    class="elr-form"
    @submit.prevent="handleSubmit"
    id="register-user"
  >
    <!-- <pre>{{errors}}</pre> -->
    <!-- <ul v-if="errors && errors.length">
      <li v-for="error in errors" :key="error.field">{{error.field}}: {{error.message}}</li>
    </ul> -->
    <div class="elr-form-row">
      <InputText
        label="First Name"
        v-model.trim="formData.first_name"
        fieldName="first_name"
        :errorMessage="(errors && errors.first_name) ? errors.first_name[0] : null"
        :required=true
      />
      <InputText
        label="Last Name"
        v-model.trim="formData.last_name"
        fieldName="last_name"
        :errorMessage="(errors && errors.last_name) ? errors.last_name[0] : null"
        :required=true
      />
    </div>
    <div class="elr-form-row">
      <InputText
        label="Email Address"
        type="email"
        v-model.trim="formData.email"
        fieldName="email"
        :errorMessage="(errors && errors.email) ? errors.email[0] : null"
        :required=true
      />
    </div>
    <div class="elr-form-row">
        <InputText
          label="Password"
          v-model.trim="formData.password"
          fieldName="password"
          type="password"

          :errorMessage="(errors && errors.password) ? errors.password[0] : null"
          :required=true
        />
        <InputText
          label="Confirm Password"
          v-model.trim="formData.password_confirmation"
          fieldName="password_confirmation"
          type="password"

          :errorMessage="(errors && errors.password_confirmation) ? errors.password_confirmation[0] : null"
          :required=true
        />
    </div>
    <div class="elr-form-row">
      <InputText
        label="User Name"
        v-model.trim="formData.username"
        fieldName="username"
        :errorMessage="(errors && errors.username) ? errors.username[0] : null"
        :required=true
      />
    </div>
    <div class="elr-form-row">
      <InputSelect
        label="Country"
        v-model.trim="formData.country"
        fieldName="country"
        :values="countries"
        :errorMessage="(errors && errors.country) ? errors.country[0] : null"
        :required=true
      />
      <InputText
        label="Sign Up Code"
        v-model.trim="formData.sign_up_code"
        fieldName="sign_up_code"
        :errorMessage="(errors && errors.sign_up_code) ? errors.sign_up_code[0] : null"
        :required=true
      />
    </div>
    <div class="elr-form-row elr-flex-justify-center">
      <button id="button-register-user" type="submit" class="elr-button elr-button-primary elr-full">Create Your Account</button>
    </div>
    <div class="elr-form-row elr-flex-justify-center">
      <p class="form-legal">You agree to the MyLittlePonyCollection <router-link to="/privacy">Privacy Policy</router-link> and <router-link to="/terms-of-service">Terms of Service</router-link>.</p>
    </div>
  </form>
</div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import InputSelect from '../InputSelect/InputSelect';
import InputText from '../InputText/InputText';
import { validate } from '../../utils/validation';
import { countries } from '../../data/config';
// import InputSelect from '../InputSelect/InputSelect';

export default {
  name: 'FormRegisterUser',
  data() {
    return {
      showPassword: false,
      passwordLabel: 'Show Password',
      formData: {
        first_name: null,
        last_name: null,
        username: null,
        email: null,
        password: null,
        password_confirmation: null,
        country: null,
        sign_up_code: null,
      },
      errors: [],
    };
  },
  components: {
    InputSelect,
    InputText,
  },
  computed: {
    ...mapState('currentUser', [{ serverErrors: 'errors' }]),
    fields() {
      return [
        {
          name: 'first_name',
          label: 'First Name',
          type: 'text',
          rules: 'required|isAlphaSpaces|isMinLength:2|isMaxLength:50',
        },
        {
          name: 'last_name',
          label: 'Last Name',
          type: 'text',
          rules: 'required|isAlphaSpaces|isMinLength:2|isMaxLength:50',
        },
        {
          name: 'username',
          label: 'User Name',
          type: 'text',
          rules: 'required|isAlphaNumeric|isMinLength:2|isMaxLength:15',
        },
        {
          name: 'email',
          label: 'Email',
          type: 'email',
          rules: 'required|isEmail|isMinLength:2|isMaxLength:100',
        },
        {
          name: 'password',
          label: 'Password',
          type: 'password',
          rules: 'required|isPassword|isMinLength:8|isMaxLength:15',
        },
        {
          name: 'password_confirmation',
          label: 'Password',
          type: 'password',
          rules: `required|isPassword|isMinLength:8|isMaxLength:15|isConfirmed:${this.formData.password},password`,
        },
        {
          name: 'country',
          label: 'Country',
          type: 'select',
          rules: 'required',
        },
        {
          name: 'sign_up_code',
          label: 'Sign Up Code',
          type: 'text',
          rules: 'required',
        },
      ]
    },
    countries() {
      return countries;
    },
  },
  mounted() {
    this.RESET_ERRORS();
  },
  methods: {
    ...mapActions('user', ['REGISTER_USER']),
    ...mapActions('currentUser', ['RESET_ERRORS', 'SET_ERROR',]),
    validate(data) {
      const errors = validate(this.fields, data);

      if (this.hasErrors(errors)) {
        this.SET_ERROR({ errors });
        this.$emit('error', { errors });
        this.errors = errors;

        return true
      }

      return false;
    },
    hasErrors(errors) {
      if (errors) {
        return !!Object.keys(errors).length;
      }

      return false;
    },
    inErrors(errors, field) {
      if (!this.hasErrors(errors)) {
        return;
      }

      const keys = Object.keys(errors);

      return keys.includes(field)
    },
    resetForm() {
      this.formData = {
        first_name: null,
        last_name: null,
        username: null,
        email: null,
        password: null,
        password_confirmation: null,
        country: null,
        sign_up_code: null
      };
    },
    async handleSubmit() {
      if (this.validate(this.formData)) {
        return;
      }

      await this.REGISTER_USER({ user: this.formData });

      this.RESET_ERRORS();
      this.$router.push('/dashboard');
    },
    togglePassword() {
      this.showPassword = this.showPassword ? false : true;
    },
  }
};
</script>

<style lang="scss" scoped>
.button-holder {
  margin-top: 30px;
}
</style>

